module.exports = __webpack_public_path__ + "files/SPIADI2025 - Journée Nationale - Espace Partenaires.0b38efe3552792f14072cd7419b25109.pdf";